import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { margins } from "style";
import Modal, { MODAL_SIZE } from "components/Modal";
import { Grid } from "components/Containers";
import Tabs from "components/Tabs";
import { ApplicantsSharePlainText, ApplicantsShareRichText } from "components/Missions/Applicants";

/**
 * ApplicantsShareModal
 *
 * @param {Array} applicantIds
 */
const ApplicantsShareModal = ({ applicantIds, ...props }) => {
  const [selectedTab, setSelectedTab] = useState(TABS.find((tab) => tab.default)?.key);

  const Components = {
    [TABS[0].key]: <ApplicantsSharePlainText applicantIds={applicantIds} />,
    [TABS[1].key]: <ApplicantsShareRichText applicantIds={applicantIds} />,
  };

  return (
    <Modal
      title={<FormattedMessage id="Missions.Applicants.ApplicantsShareModal.Title" />}
      size={MODAL_SIZE.medium}
      showSave={false}
      secondaryButtonMessageId="Global.Close"
      {...props}
    >
      <Grid>
        <Grid.col start={1} end={13}>
          <Tabs
            data={TABS.map((tab) => tab.title)}
            selected={TABS.findIndex((tab) => tab.key === selectedTab)}
            onSelect={(index) => setSelectedTab(TABS[index]?.key)}
            marginSize={margins.none}
          />
        </Grid.col>
        <Grid.col start={1} end={13}>
          {Components[selectedTab]}
        </Grid.col>
      </Grid>
    </Modal>
  );
};

const TABS = [
  {
    key: "plain_text",
    title: <FormattedMessage id="Missions.Applicants.ApplicantsShareModal.PlainTextTab" />,
    default: true,
  },
  {
    key: "rich_text",
    title: <FormattedMessage id="Missions.Applicants.ApplicantsShareModal.RichTextTab" />,
  },
];

ApplicantsShareModal.propTypes = {
  applicantIds: PropTypes.array.isRequired,
};

export default ApplicantsShareModal;
